import {
  BECOME_COLLEGE_AMBASSADOR_REQUEST,
  BECOME_COLLEGE_AMBASSADOR_SUCCEEDED,
  BECOME_COLLEGE_AMBASSADOR_FAILED,
  GET_LANDING_NEPAL_COLLEGE_DROPDOWN_REQUEST,
  GET_LANDING_NEPAL_COLLEGE_DROPDOWN_SUCCEEDED,
  GET_LANDING_NEPAL_COLLEGE_DROPDOWN_FAILED,
  GET_COLLEGE_LIST_REQUEST,
  GET_COLLEGE_LIST_SUCCEEDED,
  GET_COLLEGE_LIST_FAILED,
  ADD_COLLEGE_REQUEST,
  ADD_COLLEGE_SUCCEEDED,
  ADD_COLLEGE_FAILED,
  EDIT_COLLEGE_REQUEST,
  EDIT_COLLEGE_SUCCEEDED,
  EDIT_COLLEGE_FAILED,
  DELETE_COLLEGE_REQUEST,
  DELETE_COLLEGE_SUCCEEDED,
  DELETE_COLLEGE_FAILED,
  GET_COLLEGE_AMBASSADOR_FORM_LIST_REQUEST,
  GET_COLLEGE_AMBASSADOR_FORM_LIST_SUCCEEDED,
  GET_COLLEGE_AMBASSADOR_FORM_LIST_FAILED,
  SET_COLLEGE_DATA,
  SET_COLLEGE_EDIT_DATA,
  EDIT_COLLEGE_AMBASSADOR_FORM_REQUEST,
  EDIT_COLLEGE_AMBASSADOR_FORM_SUCCEEDED,
  EDIT_COLLEGE_AMBASSADOR_FORM_FAILED,
  GET_COLLEGE_AMBASSADOR_FORM_BY_ID_REQUEST,
  GET_COLLEGE_AMBASSADOR_FORM_BY_ID_SUCCEEDED,
  GET_COLLEGE_AMBASSADOR_FORM_BY_ID_FAILED,
} from './index';

export const becomeCollegeAmbassador = (data = {}) => {
  return {
    type: BECOME_COLLEGE_AMBASSADOR_REQUEST,
    payload: {
      data,
      url: 'colleges-ambassador-form/',
      onSuccess: BECOME_COLLEGE_AMBASSADOR_SUCCEEDED,
      onFailure: BECOME_COLLEGE_AMBASSADOR_FAILED,
    },
  };
};

export const getLandingNepalCollegeDropdown = ({ data = {} }) => {
  let query = '';
  if (data) {
    Object.keys(data).map((each) => {
      query = `${query}&${each}=${data[each]}`;
    });
  }
  return {
    type: GET_LANDING_NEPAL_COLLEGE_DROPDOWN_REQUEST,
    payload: {
      url: `colleges-list-nepal/?${query}`,
      onSuccess: GET_LANDING_NEPAL_COLLEGE_DROPDOWN_SUCCEEDED,
      onFailure: GET_LANDING_NEPAL_COLLEGE_DROPDOWN_FAILED,
    },
  };
};

//for dashboard
export const getCollegeAmbassadorFormList = (data = {}) => {
  let query = '';
  if (data) {
    Object.keys(data).map((each) => {
      query = `${query}&${each}=${data[each]}`;
    });
  }
  return {
    type: GET_COLLEGE_AMBASSADOR_FORM_LIST_REQUEST,
    payload: {
      url: `colleges/ambassador/?${query}`,
      onSuccess: GET_COLLEGE_AMBASSADOR_FORM_LIST_SUCCEEDED,
      onFailure: GET_COLLEGE_AMBASSADOR_FORM_LIST_FAILED,
    },
  };
};

export const getCollegeAmbassadorFormById = (id) => {
  return {
    type: GET_COLLEGE_AMBASSADOR_FORM_BY_ID_REQUEST,
    payload: {
      url: `colleges/ambassador/${id}/`,
      onSuccess: GET_COLLEGE_AMBASSADOR_FORM_BY_ID_SUCCEEDED,
      onFailure: GET_COLLEGE_AMBASSADOR_FORM_BY_ID_FAILED,
    },
  };
};

export const editCollegeAmbassadorForm = (data = {}, id = {}) => {
  return {
    type: EDIT_COLLEGE_AMBASSADOR_FORM_REQUEST,
    payload: {
      data,
      url: `colleges/ambassador/${id}/`,
      onSuccess: EDIT_COLLEGE_AMBASSADOR_FORM_SUCCEEDED,
      onFailure: EDIT_COLLEGE_AMBASSADOR_FORM_FAILED,
    },
  };
};

export const getColleges = (data = {}) => {
  let query = '';
  if (data) {
    Object.keys(data).map((each) => {
      query = `${query}&${each}=${data[each]}`;
    });
  }
  return {
    type: GET_COLLEGE_LIST_REQUEST,
    payload: {
      url: `colleges/list/?${query}`,
      onSuccess: GET_COLLEGE_LIST_SUCCEEDED,
      onFailure: GET_COLLEGE_LIST_FAILED,
    },
  };
};

export const addCollege = (data = {}) => {
  return {
    type: ADD_COLLEGE_REQUEST,
    payload: {
      data,
      url: 'colleges/list/',
      onSuccess: ADD_COLLEGE_SUCCEEDED,
      onFailure: ADD_COLLEGE_FAILED,
    },
  };
};

export const editCollege = (data = {}, id = {}) => {
  return {
    type: EDIT_COLLEGE_REQUEST,
    payload: {
      data,
      url: `colleges/list/${id}/`,
      onSuccess: EDIT_COLLEGE_SUCCEEDED,
      onFailure: EDIT_COLLEGE_FAILED,
    },
  };
};

export const deleteCollege = (id = {}) => {
  return {
    type: DELETE_COLLEGE_REQUEST,
    payload: {
      url: `colleges/list/${id}/`,
      onSuccess: DELETE_COLLEGE_SUCCEEDED,
      onFailure: DELETE_COLLEGE_FAILED,
    },
  };
};

export const setCollegeEditData = (payload) => {
  return {
    type: SET_COLLEGE_EDIT_DATA,
    payload,
  };
};

export const setCollegeData = (payload) => {
  return {
    type: SET_COLLEGE_DATA,
    payload,
  };
};